import { render, staticRenderFns } from "./WarningOctagon.vue?vue&type=template&id=7e0653f4&scoped=true"
import script from "./WarningOctagon.vue?vue&type=script&lang=js"
export * from "./WarningOctagon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0653f4",
  null
  
)

export default component.exports